import { TextCell } from "@silevis/reactgrid";
import { ICellTypeHandler } from "components/grecoreactgrid/ICellTypeHandler";

// GrecoReactGrid always asks the "selectall" handler for the header cell of a
// "select" column. Only one insurer report can be selected at a time, so there is
// no select-all: the header of the checkbox column is a plain empty header cell.
class SelectAllCellTypeHandler implements ICellTypeHandler {
  cellType = "selectall";
  isCustom = false;
  instance = null;
  determineNewValue = (change: any) => {
    return (change.newCell as TextCell).text;
  };
  getEntryRow = (
    entry: any,
    columnConfig: any,
    rowsMetadataMap: any,
    keyColumn: string,
    context: {
      [key: string]: any;
    }
  ) => {
    return {
      type: "header",
      text: "",
    };
  };
}

export default SelectAllCellTypeHandler;
